import React, { useState, useEffect } from "react";
import "../../../styles/Part4.css";
import TalkQuestion from "./TalkQuestion";
import { broadcastData } from "../../../data/part4/broadcastData";
import { tourData } from "../../../data/part4/tourData";
import { advertisementData } from "../../../data/part4/advertisementData";
import { telephoneData } from "../../../data/part4/telephoneData";
import { announcementData } from "../../../data/part4/announcementData";
import { speechData } from "../../../data/part4/speechData";
import { db, auth } from "../../../firebase";
import { doc, setDoc, getDoc } from "firebase/firestore";
import { freeContent } from "../../../utils/freeContent";

const Part4_1 = ({ isActive }) => {
  const [selectedCategory, setSelectedCategory] = useState(null);
  const [currentTalkIndex, setCurrentTalkIndex] = useState(0);
  const [completedCategories, setCompletedCategories] = useState({});

  useEffect(() => {
    // 사용자의 학습 완료 상태 불러오기
    const loadCompletedCategories = async () => {
      if (!auth.currentUser) return;

      const userRef = doc(db, "users", auth.currentUser.uid);
      const userDoc = await getDoc(userRef);

      if (userDoc.exists()) {
        const data = userDoc.data();
        setCompletedCategories(data.part4CompletedCategories || {});
      }
    };

    loadCompletedCategories();
  }, []);

  const handleComplete = async (categoryKey) => {
    console.log("handleComplete 실행", {
      categoryKey,
      currentUser: auth.currentUser,
    });

    if (!auth.currentUser) {
      console.log("사용자가 로그인되어 있지 않음");
      return;
    }

    try {
      const updatedCategories = {
        ...completedCategories,
        [categoryKey]: true,
      };

      console.log("업데이트할 데이터:", updatedCategories);

      // Firestore에 저장
      const userRef = doc(db, "users", auth.currentUser.uid);
      await setDoc(
        userRef,
        {
          part4CompletedCategories: updatedCategories,
        },
        { merge: true }
      );

      console.log("Firestore 저장 완료");

      setCompletedCategories(updatedCategories);
      setSelectedCategory(null);
      setCurrentTalkIndex(0);

      console.log("상태 업데이트 완료");
    } catch (error) {
      console.error("학습 완료 처리 중 오류 발생:", error);
    }
  };

  const subCategories = {
    broadcast: {
      title: "방송 & 뉴스",
      description: "뉴스 업데이트, 라디오 프로그램, 날씨, 교통 정보 등",
      examples: ["지역 뉴스", "날씨 예보", "교통 정보"],
      data: broadcastData,
    },
    tour: {
      title: "투어",
      description: "관광지 안내, 박물관 투어, 역사적 장소 설명",
      examples: ["박물관 투어", "관광지 설명", "역사 유적 안내"],
      data: tourData,
    },
    advertisement: {
      title: "광고 & 홍보",
      description: "제품 광고, 서비스 홍보, 프로모션 안내",
      examples: ["신제품 출시", "할인 행사", "특별 프로모션"],
      data: advertisementData,
    },
    telephone: {
      title: "전화 메시지",
      description: "음성 메시지, 전화 안내, 자동 응답",
      examples: ["부재중 메시지", "회의 일정 변경", "연락처 정보"],
      data: telephoneData,
    },
    announcement: {
      title: "공지(Announce)",
      description: "공공장소 안내, 이벤트 정보, 긴급 공지",
      examples: ["공항 안내", "행사 일정", "긴급 방송"],
      data: announcementData,
    },
    speech: {
      title: "연설 & 발표",
      description: "기업 연설, 행사 연설, 교육 강연",
      examples: ["기업 발표", "시상식 연설", "교육 강연"],
      data: speechData,
    },
  };

  const handleCategoryClick = (categoryKey) => {
    setSelectedCategory(categoryKey);
    setCurrentTalkIndex(0);
  };

  const handleBack = () => {
    setSelectedCategory(null);
    setCurrentTalkIndex(0);
  };

  if (selectedCategory) {
    const categoryData = subCategories[selectedCategory].data;
    const talks = Object.values(categoryData);
    const currentTalk = talks[currentTalkIndex];
    const hasNext = currentTalkIndex < talks.length - 1;

    console.log("TalkQuestion으로 전달되는 props:", {
      selectedCategory,
      currentTalkIndex,
      hasNext,
    });

    return (
      <TalkQuestion
        talk={currentTalk}
        onBack={handleBack}
        onNext={() => setCurrentTalkIndex((prev) => prev + 1)}
        onPrevious={() => setCurrentTalkIndex((prev) => prev - 1)}
        onComplete={() => {
          console.log("TalkQuestion에서 onComplete 호출됨");
          handleComplete(selectedCategory);
        }}
        hasNext={hasNext}
        currentIndex={currentTalkIndex}
        totalCount={talks.length}
      />
    );
  }

  return (
    <div className="part4-container">
      <div className="subcategory-selection">
        <h2>TOEIC Part 4 - 설명문 이해</h2>
        <div className="subcategory-grid">
          {Object.entries(subCategories).map(([key, category]) => {
            const isFreeContent = freeContent.part4.talks.includes(key);

            return (
              <div
                key={key}
                className={`subcategory-card ${
                  !isActive && !isFreeContent ? "premium" : ""
                }`}
                onClick={() => {
                  if (!isActive && !isFreeContent) {
                    return; // 구독하지 않은 사용자는 잠긴 카테고리 접근 불가
                  }
                  handleCategoryClick(key);
                }}
                style={{ cursor: "pointer" }}
              >
                <h3>{category.title}</h3>
                <p>{category.description}</p>
                {!isActive && !isFreeContent && (
                  <div className="lock-overlay">
                    <img src="/icons/lock.svg" alt="잠김" />
                  </div>
                )}
                {completedCategories[key] && (
                  <div className="completion-badge">학습완료</div>
                )}
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default Part4_1;
